import React from "react";
import NSWSvg from "./nsw-svg";
import styles from "./map-buttons.module.scss";
import PropTypes from "prop-types";

const ZoomNswButton = ({ onClick, ariaLabel, activePage, isMobile }) => {
    return (
        <button
            className={`${styles.headerButton} ${styles.nswButton}`}
            onClick={() => {
                onClick();
            }}
            aria-label={ariaLabel}
            tabIndex={1}
        >
            {!isMobile && (
                <span>{activePage === "map" ? "Zoom to NSW" : "Show all projects"}</span>
            )}
            <NSWSvg width={25} />
        </button>
    );
};

ZoomNswButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    activePage: PropTypes.string,
    isMobile: PropTypes.bool,
};

export default ZoomNswButton;



// WEBPACK FOOTER //
// ./src/components/ui/map-buttons/ZoomNswButton.js